export const APP_NAME = 'Siglo 21 Empleos'
export const PERSIST_STORE_NAME = 'siglo21-empleos'
export const REDIRECT_URL_KEY = 'redirectUrl'
export const APP_XUSER_CODE = 'P-EMP'
export const URL = 'http://172.20.1.63:3000'